import { DataParamsApi } from "@impero-com/ui/domain";

import { GetTestingProgramsTestingProgramIdActivitiesParams } from "api/generated/model";

import { testingActivityListDataParamsCodecMap } from "./consts";

export interface TestingActivityArchivedFilters {
    active: boolean;
    archived: boolean;
    setActive: (checked: boolean) => void;
    setArchived: (checked: boolean) => void;
}

export interface TestingActivityArchivedFilterResult extends TestingActivityArchivedFilters {
    /**
     * Backend `archived` query param: `false` = active only, `true` = archived
     * only, `undefined` = both (param omitted).
     */
    archivedParam: GetTestingProgramsTestingProgramIdActivitiesParams["archived"];
    /** False when neither box is checked; nothing should be listed. */
    isEnabled: boolean;
    /**
     * True when the checkboxes differ from their default (active-only) state.
     * Lets the filter bar count the archive filter as one applied filter.
     */
    isNonDefault: boolean;
}

function getArchivedParam(
    active: boolean,
    archived: boolean
): GetTestingProgramsTestingProgramIdActivitiesParams["archived"] {
    if (active && archived) {
        return undefined;
    }
    if (archived) {
        return true;
    }
    // Active-only and the "neither checked" case both reuse the active query;
    // the empty case is hidden via `isEnabled`.
    return false;
}

export function getTestingActivityArchivedFilter(
    dataParams: DataParamsApi<typeof testingActivityListDataParamsCodecMap>
): TestingActivityArchivedFilterResult {
    const { active, archived } = dataParams.values;
    return {
        active,
        archived,
        setActive: (checked) => dataParams.setValue("active", checked),
        setArchived: (checked) => dataParams.setValue("archived", checked),
        archivedParam: getArchivedParam(active, archived),
        isEnabled: active || archived,
        // Default is active-only; hiding active or showing archived is non-default.
        isNonDefault: !active || archived,
    };
}
